
import { useNavigate } from "react-router-dom";
import { Building2 } from "lucide-react";
import { useAdminCustomization } from "@/hooks/useAdminCustomization";

interface HeaderLogoProps {
  compact?: boolean;
}

export const HeaderLogo = ({ compact = false }: HeaderLogoProps) => {
  const navigate = useNavigate();
  const { customization } = useAdminCustomization();

  const primaryColor = customization?.primary_color || '221 83% 53%';

  if (compact) {
    return (
      <div 
        className="flex items-center cursor-pointer gap-2" 
        onClick={() => navigate("/")}
      >
        <img 
          src={customization?.logo_url || "/ovit-logo.png"} 
          alt="Company Logo" 
          className="h-6 w-6 object-contain"
        />
        <span className="text-base font-bold" style={{ color: `hsl(${primaryColor})` }}>
          {customization?.app_name || 'Shiftask'}
        </span>
      </div>
    );
  }

  return (
    <div 
      className="flex items-center cursor-pointer gap-3" 
      onClick={() => navigate("/")}
    >
      <img 
        src={customization?.logo_url || "/ovit-logo.png"} 
        alt="Company Logo" 
        className="h-8 w-8 object-contain"
      />
      <span className="text-xl font-bold" style={{ color: `hsl(${primaryColor})` }}>
        {customization?.app_name || 'Shiftask'}
      </span>
    </div>
  );
};
